import type { SVGProps } from 'react';

const SvgAnnotationBrush = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.71 10.293a.996.996 0 0 0-1.41 0l-1.96 1.96a6.05 6.05 0 0 0-2.59-2.59l4.96-4.96a.996.996 0 1 0-1.41-1.41l-5.74 5.74c-.18-.02-.37-.03-.56-.03-2.82 0-5.2 1.96-5.83 4.6-1.08-.33-1.9-.31-2.46.05-.45.29-.71.77-.71 1.36 0 3.53 3.29 6 8 6 3.24 0 7-2.62 7-6 0-.19-.01-.37-.03-.56l2.74-2.74a.996.996 0 0 0 0-1.41zM11 19.003c-3.34 0-5.73-1.47-5.98-3.62.34.06.89.21 1.55.51.31.14.69.12.97-.06.29-.18.46-.5.46-.84 0-2.2 1.8-3.99 4-3.99s4 1.79 4 4-2.75 4-5 4"
    />
  </svg>
);
export default SvgAnnotationBrush;
